import {
  browserLocalPersistence,
  onAuthStateChanged,
  setPersistence,
  signInWithCustomToken,
  signOut,
  User,
} from 'firebase/auth';

import { auth } from './firebase';

const ensureFirebasePersistence = async (): Promise<void> => {
  await setPersistence(auth, browserLocalPersistence);
};

/**
 * Signs in with Firebase using a custom token from the backend.
 * With this we can use auth.currentUser to get the authenticated user.
 */
export const signInWithFirebaseToken = async (customToken: string): Promise<void> => {
  await ensureFirebasePersistence();
  await signInWithCustomToken(auth, customToken);
};

/**
 * Signs out from Firebase.
 */
export const signOutFromFirebase = async (): Promise<void> => {
  await signOut(auth);
};

/**
 * Sets up a listener for Firebase auth state changes.
 * Returns an unsubscribe function.
 */
export const onFirebaseAuthStateChanged = (callback: (user: User | null) => void): (() => void) => {
  return onAuthStateChanged(auth, callback);
};

/**
 * Gets the current Firebase user UID, or null if not authenticated.
 */
export const getCurrentFirebaseUid = (): string | null => {
  return auth.currentUser?.uid ?? null;
};
